// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityIndividual {
    static getAttributeTypeMap() {
        return MedicalEligibilityIndividual.attributeTypeMap;
    }
}
MedicalEligibilityIndividual.discriminator = undefined;
MedicalEligibilityIndividual.additionalProperties = false;
MedicalEligibilityIndividual.attributeTypeMap = [
    {
        "name": "coInsurance",
        "baseName": "coInsurance",
        "type": "string"
    },
    {
        "name": "deductible",
        "baseName": "deductible",
        "type": "string"
    },
    {
        "name": "deductibleMet",
        "baseName": "deductibleMet",
        "type": "string"
    },
    {
        "name": "deductibleRemaining",
        "baseName": "deductibleRemaining",
        "type": "string"
    },
    {
        "name": "deductibleOutNetwork",
        "baseName": "deductibleOutNetwork",
        "type": "string"
    },
    {
        "name": "deductibleRemainingOutNetwork",
        "baseName": "deductibleRemainingOutNetwork",
        "type": "string"
    },
    {
        "name": "oop",
        "baseName": "oop",
        "type": "string"
    },
    {
        "name": "oopMet",
        "baseName": "oopMet",
        "type": "string"
    },
    {
        "name": "oopRemaining",
        "baseName": "oopRemaining",
        "type": "string"
    },
    {
        "name": "oopOutNetwork",
        "baseName": "oopOutNetwork",
        "type": "string"
    },
    {
        "name": "oopRemainingOutNetwork",
        "baseName": "oopRemainingOutNetwork",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityIndividual.js.map